import classnames from 'classnames';
import PropTypes from 'prop-types';

import Button from 'shared/components/button/Button';
import VisibilityToggle from 'shared/components/VisibilityToggle';

import styles from './index.module.scss';

const Dropdown = ({
  children,
  items,
  onChange,
  selected = 0,
  transparent = false,
}) => (
  <VisibilityToggle
    render={({ visible, onToggleClick, insideRefHandler }) => (
      <div className={styles.wrapper} ref={insideRefHandler}>
        <Button
          className={classnames(styles.dropDown, {
            [styles.active]: visible,
            [styles.transparent]: transparent,
          })}
          onClick={onToggleClick}
        >
          {children}
          <div className={styles.triangle} />
        </Button>

        <div
          className={classnames(styles.list, {
            [styles.active]: visible,
          })}
        >
          {items.map((item, i) => (
            <Button
              className={classnames(styles.item, {
                [styles.selected]: (item.value || item) === selected,
              })}
              key={i}
              onClick={() => {
                onChange(items[i]);
                onToggleClick();
              }}
            >
              {item.text || item}
            </Button>
          ))}
        </div>
      </div>
    )}
  />
);

Dropdown.propTypes = {
  children: PropTypes.any,
  items: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    ),
    PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
          .isRequired,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
          .isRequired,
      }).isRequired,
    ),
  ]).isRequired,
  onChange: PropTypes.func,
  selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  transparent: PropTypes.bool,
};

export default Dropdown;
